import { apiGatewayEndpoints } from '~/services/arcane-api-gateway/api-gateway-endpoints';
import { fastApiEndpoints } from '~/services/arcane-fast-api/fast-api-endpoints';

import { featureFlags } from '~/utils/featureFlags';

import { getClient } from './clients';

const FLAG = 'useFastApi';

export const fetchMediaImages = ({ query, orgId, filter, from, size }) => {
  const client = getClient(FLAG);

  if (featureFlags[FLAG]) {
    const endpoint = query ? fastApiEndpoints.image.search : fastApiEndpoints.image.list;
    const body = {
      size,
      start: from,
      filters: filter,
      ...(query ? { term: query } : {}),
    };
    return client.post(endpoint, body);
  }

  return client.post(apiGatewayEndpoints.mediaImages, { query, orgId, filter, from, size });
};
